module.exports = __webpack_public_path__ + "img/product-category-diamondjewelry@2x.ce785ab.webp";